import type { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';

import { ServerSideError } from './server-side-error';

export class RedirectError extends ServerSideError {
  private readonly subdomain: string;
  private readonly path?: string;

  constructor(message: string, subdomain: string, path?: string) {
    super(message, 'Redirect Error');
    this.subdomain = subdomain;
    this.path = path;
  }

  public getServerSidePropsResult(
    context: GetServerSidePropsContext
  ): GetServerSidePropsResult<any> {
    return this.getRedirectServerSidePropsResult(
      context,
      this.subdomain,
      this.path
    );
  }
}
